export default "__VITE_ASSET__l9n3k183__"